import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequest, handleDynamicRequestHeader, handleDynamicRequestHeaderMulter } from '../components/DyanamicRequest';

// Create a new feed topic
export const createFeedTopic = async (topicData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    formData.append('topic_name', topicData.topic_name);
    if (topicData.cid) formData.append('cid', topicData.cid);
    if (topicData.mid) formData.append('mid', topicData.mid);
    if (topicData.priority) formData.append('priority', topicData.priority);
    if (topicData.image) formData.append('image', topicData.image);
    if (topicData.active !== undefined) formData.append('active', String(topicData.active));
    if (topicData.disabled !== undefined) formData.append('disabled', String(topicData.disabled));
    if (topicData.options !== undefined && topicData.options !== '') formData.append('options', topicData.options);
    if (topicData.tag !== undefined && topicData.tag !== '') formData.append('tag', topicData.tag);

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'POST',
      `${BASE_URL}/admin/feed-topics`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to create feed topic' }),
      (response) => resolve(response)
    );
  });
};

// Get feed topics
export const getFeedTopics = async () => {
  return new Promise((resolve) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeader(
      'GET',
      `${BASE_URL}/admin/feed-topics`,
      null,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to fetch feed topics' }),
      (response) => resolve(response)
    );
  });
};

// Update a feed topic
export const updateFeedTopic = async (topicId, topicData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    
    if (topicData.topic_name) formData.append('topic_name', topicData.topic_name);
    if (topicData.cid) formData.append('cid', topicData.cid);
    if (topicData.mid) formData.append('mid', topicData.mid);
    if (topicData.priority) formData.append('priority', topicData.priority);
    if (topicData.image) formData.append('image', topicData.image);
    if (topicData.active !== undefined) formData.append('active', String(topicData.active));
    if (topicData.disabled !== undefined) formData.append('disabled', String(topicData.disabled));
    if (topicData.options !== undefined && topicData.options !== '') formData.append('options', topicData.options);
    if (topicData.tag !== undefined && topicData.tag !== '') formData.append('tag', topicData.tag);

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'PUT',
      `${BASE_URL}/admin/feed-topics/${topicId}`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to update feed topic' }),
      (response) => resolve(response)
    );
  });
};

// Delete a feed topic
export const deleteFeedTopic = async (topicId) => {
  return new Promise((resolve) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    // Custom DELETE request without body
    fetch(`${BASE_URL}/admin/feed-topics/${topicId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': token
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data) {
        resolve(data);
      } else {
        resolve({ statusCode: "50000", message: 'Failed to delete feed topic' });
      }
    })
    .catch(error => {
      console.error('API Error:', error);
      resolve({ statusCode: "50000", message: 'Failed to delete feed topic' });
    });
  });
};

